import styled from 'styled-components';
import { TextField } from '@mui/material';
import { ChangeEvent, FocusEvent } from 'react';


const StyledTextField = styled(TextField)`
.Mui-error {
    border-color: red;
}
`;

interface DateInputProps {
    label: string;
    placeholder: string;
    error: boolean;
    value: string;
    onChange: ((event: ChangeEvent<HTMLInputElement>) => void);
    onBlur: (event: FocusEvent<HTMLInputElement>) => void;
    min: string;
    [key: string]: unknown;

}

const DateInputComponent = ({
    label,
    placeholder,
    error,
    value,
    onChange,
    onBlur,
    min,
    ...props
}: DateInputProps) => {
    return (
        <StyledTextField
            id={label.trim()}
            type="date"
            placeholder={placeholder}
            error={Boolean(error)}
            variant="outlined"
            value={value}
            aria-label={label}
            aria-invalid={Boolean(error)}
            onChange={onChange as ((event: ChangeEvent<HTMLInputElement>) => void)}
            onBlur={onBlur}
            inputProps={{ min }}
            className={error ? 'error' : ''}
            {...props}
        />
    );
};

export default DateInputComponent;